import { render, staticRenderFns } from "./inquireDetail.vue?vue&type=template&id=5f1b3510&"
import script from "./inquireDetail.vue?vue&type=script&lang=js&"
export * from "./inquireDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports